module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAKNJREFUKBVjYMANjIFS5rikWXBJAMW5gBinPBMejXilRqpGZiyhgiGGIQDUlADVyA6kQYHHA8S+QHwOiOEApDEFiC8D8T+o6HMg7QHEvEAsCMSqQLwRiL8AMQiwAnEiyER+KAdIgcFLILkGiEEJgBuI1wIxyDAYAGkUwJUyQJqXAzEjEL8FYgwA08iHIcPA8AMqBrIZGYDVgkwMAWJ5ZBki2A8AwJwQOA5Um3sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/xiazai.png
// module id = wr01
// module chunks = 1